import DateBox from 'devextreme-react/date-box';
import Switch from 'devextreme-react/switch';
import TextArea from 'devextreme-react/text-area';
import Toolbar from 'devextreme-react/toolbar';
import moment from 'moment';
import React, { useEffect, useMemo, useState } from 'react';
import { Modal } from 'semantic-ui-react';
import { chamSocKhachHangApi } from '../../../api/chamSocKhachHangApi';
import { hocSinhApi } from '../../../api/hocsinh_api';
import { phuHuynhApi } from '../../../api/phuHuynhApi';
import { showNotify } from '../../../helpers/toast';
import HocSinhProfile from '../../../pages/hoc-sinh-profile/HocSinhProfile';
import { DefaultButton, PrimaryButton } from '../../editor/button';
import { FormGroupInline } from '../../form-group';
import styles from "./CSKHForm.module.css";
import { useSelector } from 'react-redux';
const options = [
    { id: 1, name: "Ghi chú từ Tuyển sinh", icon: 'group' },
    { id: 2, name: "Yêu cầu từ Phụ huynh", icon: "user" },
]
const CSKHForm = ({ ts_phuhuynh_id, onSuccess, onGhiDanhSuccess, isHideGhiDanh }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const [optionSelectedId, setOptionSelectedId] = useState(1);
    const [phuHuynhStatusId, setPhuHuynhStatusId] = useState(-1);
    const [isDone, setIsDone] = useState(false);
    const [noiDung, setNoiDung] = useState("");
    const [hocSinhs, setHocSinhs] = useState([])
    const [hocSinhSelectedId, setHocSinhSelectedId] = useState(0);
    const [henXuLy, setHenXuLy] = useState("");
    const [phuHuynh, setPhuHuynh] = useState({})
    const [phuHuynhStatus, setPhuHuynhStatus] = useState([]);
    const [isShowDetailModal, setIsShowDetailModal] = useState(false);
    const { dm_coso_id } = useSelector(x => x.coSo);
    
    useEffect(() => {
        setPhuHuynhStatusId(phuHuynh.ts_phuhuynh_adm_status_id);
    }, [phuHuynh])

    useEffect(() => {
        handleReloadPhuHuynh();
        hanleReloadPhuHuynhStatus();
    }, [])
    useEffect(() => {
        if (isExpanded && hocSinhs.length == 0) {
            handleReloadHocSinhs();
        }
    }, [isExpanded])
    const isValid = useMemo(() => {
        if (noiDung == "") return false;
        return true;
    }, [noiDung])
    const handleReloadPhuHuynh = async () => {
        const res = await phuHuynhApi.Detail(ts_phuhuynh_id)
        if (res.is_success) {
            setPhuHuynh(res.data);
        }

    }
    const handleReloadHocSinhs = async () => {
        const res = await hocSinhApi.SelectByParent(ts_phuhuynh_id);
        if (res.is_success) {
            let _hocSinhs = [{
                id: 0,
                ho_ten: "Không gán vào học sinh"
            }]
            res.data = res.data.filter(x => x.dm_coso_id == dm_coso_id);
            res.data.forEach(element => {
                _hocSinhs.push({ id: element.id, ho_ten: "Là yêu cầu của " + element.ho_ten })
            });
            setHocSinhs(_hocSinhs);
        }
    }
    const hanleReloadPhuHuynhStatus = async () => {
        const res = await phuHuynhApi.SelectStatus();
        if (res.is_success) {
            setPhuHuynhStatus(res.data.map(x => {
                return {
                    ...x,
                    name: `Trạng thái Phụ huynh: ${x.name}`
                }
            }));
        }
    }
    const onSubmit = async () => {
        const res = await chamSocKhachHangApi.Insert({
            noi_dung: noiDung,
            is_request: optionSelectedId == 2,
            ts_phuhuynh_id: ts_phuhuynh_id,
            ts_hocsinh_id: hocSinhSelectedId,
            dien_thoai: phuHuynh.dien_thoai,
            ten_khach_hang: phuHuynh.ho_ten,
            ngay_hen_tra_loi_text: henXuLy,
            da_xu_ly: isDone,
            ts_phuhuynh_adm_status_id: phuHuynhStatusId,
            dm_coso_id: dm_coso_id
        });
        if (res.is_success) {
            showNotify({ text: "Thêm mới thành công", type: "success" });
            if (onSuccess) {
                onSuccess();
            }
            setIsExpanded(false)
            setHocSinhSelectedId(0)
            setOptionSelectedId(0)
            setNoiDung("")

        } else {
            showNotify({ text: "Thêm mới thất bại", type: "error" });
        }
    }


    const toolbarItems = [

        {
            location: 'before',
            widget: 'dxDropDownButton',
            options: {
                displayExpr: 'name',
                keyExpr: 'id',
                selectedItemKey: optionSelectedId,
                width: 220,
                stylingMode: 'text',
                useSelectMode: true,
                onSelectionChanged: (e) => {
                    setOptionSelectedId(e.item.id);
                    // this.setState({
                    //     alignment: e.item.name.toLowerCase(),
                    // });
                },
                items: options,
            },
        },
        {
            location: 'before',
            widget: 'dxDropDownButton',
            options: {
                displayExpr: 'ho_ten',
                keyExpr: 'id',
                selectedItemKey: hocSinhSelectedId,
                width: 280,
                stylingMode: 'text',
                useSelectMode: true,
                onSelectionChanged: (e) => {
                    setHocSinhSelectedId(e.item.id);
                    // this.setState({
                    //     alignment: e.item.name.toLowerCase(),
                    // });
                },
                items: hocSinhs,
            },
        },
    ];
    const toolbarStatusItems = [

        {
            location: 'before',
            widget: 'dxDropDownButton',
            options: {
                displayExpr: 'name',
                keyExpr: 'id',
                selectedItemKey: phuHuynhStatusId,
                width: 300,
                stylingMode: 'text',
                useSelectMode: true,
                onSelectionChanged: (e) => {
                    setPhuHuynhStatusId(e.item.id);
                    // this.setState({
                    //     alignment: e.item.name.toLowerCase(),
                    // });
                },
                items: phuHuynhStatus,
            },
        },

    ];
    return (
        <div className={styles.form}>
            <div className={styles.caption}>
                Thêm lịch sử chăm sóc
            </div>
            {isExpanded &&
                <div className={styles.actions_top}>
                    <div className={styles.left}>
                        <div className={styles.item}>
                            <Toolbar items={toolbarItems} className={styles.toolbar}>
                            </Toolbar>
                        </div>
                    </div>
                </div>
            }
            <div>

                <TextArea
                    autoResizeEnabled
                    className={styles.noboder}
                    placeholder='Điền nội dung chăm sóc'
                    stylingMode='underlined'
                    minHeight={40}
                    value={noiDung}
                    onFocusIn={() => {
                        setIsExpanded(true)
                    }}
                    valueChangeEvent="keyup"
                    onValueChanged={(e) => {
                        setNoiDung(e.value)
                    }}
                />
            </div>
            <div className={styles.actions}>
                <div className={styles.left}>

                    {isExpanded &&
                        <>
                            {optionSelectedId == 2 &&
                                <>
                                    <div className={styles.item}>
                                        <FormGroupInline label={"Đã xử lý"}>
                                            <Switch value={isDone} disabled={!isExpanded} onValueChanged={(e) => {
                                                setIsDone(e.value)
                                            }} />
                                        </FormGroupInline>
                                    </div>
                                    {!isDone &&
                                        <div className={styles.item}>
                                            <FormGroupInline label={"Hẹn xử lý lại vào ngày"}>
                                                <DateBox
                                                    stylingMode='outlined' width={150}
                                                    displayFormat="dd/MM/yyyy"
                                                    onValueChanged={(e) => {
                                                        setHenXuLy(moment(e.value).format("DD/MM/yyyy"))
                                                    }}
                                                />
                                            </FormGroupInline>
                                        </div>
                                    }
                                </>
                            }
                            <div className={styles.item}>
                                <Toolbar items={toolbarStatusItems} className={styles.toolbar}>
                                </Toolbar>
                            </div>
                        </>}

                </div>
                <div className={styles.right}>
                    <DefaultButton text={"Đóng"} onClick={() => { setIsExpanded(false) }} />{' '}
                    <PrimaryButton text={"Thêm yêu cầu"} disabled={!isExpanded || !isValid} onClick={onSubmit} />
                    {!isHideGhiDanh &&
                        <PrimaryButton text={"Ghi danh ngay"} onClick={() => { setIsShowDetailModal(true) }} />
                    }

                </div>
            </div>
            {isShowDetailModal &&
                <Modal
                    open={true}
                    size="large"
                    dimmer={'blurring'}
                    closeIcon
                    onClose={() => {
                        setIsShowDetailModal(false)
                        onGhiDanhSuccess()
                    }}
                    closeOnEscape={false}
                    closeOnDimmerClick={false}
                >
                    <Modal.Content>
                        {/* <ScrollView height={window.innerHeight - 200}> */}
                        <HocSinhProfile
                            value={0}
                            height={window.innerHeight - 200}
                            phuHuynh={phuHuynh}
                        />
                        {/* </ScrollView> */}
                    </Modal.Content>

                </Modal>
            }
        </div>
    );
};

export default CSKHForm;